/**
 * InfoIcon — Small circled "i" icon paired with a Tooltip.
 *
 * Props:
 *   tooltip   {string|node} Tooltip content (required)
 *   position  {string}   Tooltip position (default: "top")
 *   maxWidth  {number}   Tooltip max width in px (Tooltip's default when omitted)
 *   variant   {string}   Tooltip style, "dark" (default) or "light"
 *
 * Usage:
 *   <span>Section Header <InfoIcon tooltip="Explanation text" /></span>
 *
 * (PATCH-16: System-Wide Tooltip Deployment)
 */

import Tooltip from "./Tooltip";

export default function InfoIcon({ tooltip, position = "top", maxWidth, variant }) {
  if (!tooltip) return null;

  return (
    <Tooltip text={tooltip} position={position} maxWidth={maxWidth} variant={variant} inline>
      <span className="inline-flex items-center justify-center w-3.5 h-3.5 rounded-full border border-gray-300 text-gray-400 hover:text-gray-600 hover:border-gray-400 cursor-help transition-colors ml-2 text-[9px] font-bold leading-none select-none flex-shrink-0">
        i
      </span>
    </Tooltip>
  );
}
